import { Common } from '@thecvlb/design-system';
import classNames from 'classnames';

import { MessageEvent } from 'utils/enums';

import { MessageProps } from './message.types';
import AppointmentMessage from './AppointmentMessage';
import DefaultMessage from './DefaultMessage';
import File from './File';
import Status from './Status';
import SystemMessage from './SystemMessage';

import ProviderAvatar from 'assets/icons/doc-avatar.svg';

const Message = ({ combined, message, mobile, self }: MessageProps) => {
  return (
    <div
      className={classNames('md:px-4', {
        'mb-1': combined
      })}
      data-testid="message"
    >
      <div
        className={classNames(
          'flex h-fit items-end',
          {
            'flex-row-reverse': self
          },
          !self && combined && (mobile ? 'ml-14' : 'ml-12')
        )}
      >
        {!combined && !self && (
          <Common.ProfileImage
            className="mb-[26px]"
            size="lg"
            src={message.senderDetails?.profileImage || ProviderAvatar}
          />
        )}
        <div
          className={classNames('flex flex-col gap-3', {
            'items-end': self,
            'ml-3': !mobile && !self
          })}
        >
          <File combined={combined} message={message} mobile={mobile} self={self} />
          {message.event &&
          [MessageEvent.AppointmentCreated, MessageEvent.AppointmentCancelled].includes(
            message.event
          ) ? (
            <AppointmentMessage combined={combined} message={message} self={self} />
          ) : message.event &&
            [MessageEvent.AppointmentMissed, MessageEvent.AppointmentComplete].includes(
              message.event
            ) ? (
            <SystemMessage combined={combined} message={message} self={self} />
          ) : (
            <DefaultMessage combined={combined} message={message} self={self} />
          )}

          <Status combined={combined} message={message} mobile={mobile} self={self} />
        </div>
      </div>
    </div>
  );
};

export default Message;
